import { tfsToDate, dateToTimecode, isTFS } from "./TimecodeUtils";
import MessageService from 'message-service/message-service';
import DataEvents from '@gameday/core/events/DataEvents';
const { NEW_TIMECODE } = DataEvents;

// Playback Source for TFS Playback

const LIVE = 'L';
const FINAL = 'F';
const DEFAULT = 'L';
const refreshTimer = {
    [LIVE]: 10000, // 10 seconds
    [FINAL]: 30000 // 30 seconds
};

class PlaybackSource {
    constructor (_opts) {
        this.config = _opts.config;
        this.gameState = this?.config?.abstractGameCode;
        this.syncActive = false; // running or no
        this.timeMarchesOn = false; // advance? if false, the time stays constant,
        this.currentTimecode; // current timecode for gameplayback
        this.ticktock; // current time unrelated to game playback used to time difference calculation
        this.intervalId = -1;
        this.wait = refreshTimer[this.gameState] ?? refreshTimer[DEFAULT];
    }

    /**
     * Function start
     * @param startTimecode {String}
     *
     * kicks off timecode generation, sets up initial variables, makes first call to marchOn
     */
    start (startTimecode) {
        if (this.setTimecode(startTimecode)) {
            this.timeMarchesOn = true;
            this.ticktock = new Date();
            this.syncActive = true;
            this.marchOn();
        }
    }

    /**
     * Function marchOn
     *
     * controls timing. calls out to increment timecode, waits, calls itself ~recursion~
     */
    marchOn () {
        if (this.timeMarchesOn === true && this.syncActive === true) {
            this.intervalId = setTimeout(() => {
                this.incrementTimecode();
                this.marchOn(); // ~recursion~
            }, this.wait);
        }
    }

    /**
     * Function setTimecode
     * @param timecode {String}
     *
     * @return {boolean} True signifies a valid timecode has been passed.  False, invalid.
     * converts timecode to JS date format, sets class variable, publishes on message service
     */
    setTimecode (timecode) {
        if (!timecode) {
            this.stop();
            return false;
        }
        if (isTFS(timecode)) {
            this.currentTimecode = tfsToDate(timecode);
        } else {
            const newTimecode = new Date(timecode);
            if (newTimecode.getTime() > 0) {
                this.currentTimecode = newTimecode;
            } else {
                this.timeMarchesOn = false;
                return false;
            }
        }

        MessageService.publish(NEW_TIMECODE, { timecode: this.currentTimecode });

        return true;
    }

    /**
     * Function incrementTimecode
     *
     * creates new timestamp, applies difference between new timestamp
     * and ticktock to currentTimestamp in state, updates state
     */
    incrementTimecode () {
        if (this.syncActive && this.ticktock && this.timeMarchesOn) {
            const newTimecode = new Date();
            const diff = (newTimecode - this.ticktock);
            const deltaCurrentTimecode = new Date(this.currentTimecode);
            deltaCurrentTimecode.setTime(this.currentTimecode.getTime() + diff);
            this.setTimecode(deltaCurrentTimecode);
            this.ticktock = newTimecode;
        }
    }

    /**
     * Function stop
     *
     * stop timekeeping, break the loops and stop new timecodes
     */
    stop () {
        this.syncActive = false;
        clearTimeout(this.intervalId);
    }
};

export default PlaybackSource;
